<template>
  <div style ="display:flex; top:0; right:0;">
   <div>
    <div style="text-align:left;margin-left:15px;" class="mb-0">
      <span class="header">PRODUCT TYPE</span>
    </div>  
    <v-row class="white-container">
      <v-col v-for="(instrumentType) in instrumentTypes" :key="instrumentType.id"  class="px-2 py-2 pt-1" cols="6" md="3" style="border:.01px solid #C0C0C0;height: 170px;"> 
            <div class="card-container" style="height: 90%;"  @click="RouteToResult(instrumentType.product_name,instrumentType.id,instrumentType.url)">
              <img class="instrument_image" width="auto" height="60px" :src="require ('../assets/images/InstrumentTypes/'+instrumentType.img+'.png')" /> <br>
              <span  style="font-size:11px;font-weight: 600;">{{instrumentType.product_name}}</span>
            </div>
            <div style="height: 30%;font-size:11px;font-weight: bold;color:#00AA7E">
              <a :href="instrumentType.url" target="_blank"> View Product Page ></a>
            </div>
      </v-col>
    </v-row>
   </div>
   <Navigation :category_id="this.$route.params.id" style="margin-top:30px;" />
  </div>
</template>

<script>

import instrumentTypes from "../json/instrumentType.json"
import Navigation from './Navigation.vue'

export default {
  name: 'InstrumentType',
  computed:{
    instrumentTypes(){
      var instrument_types = []
      for(var i = 0; i < instrumentTypes.length; i++){
        if(instrumentTypes[i].category_id == this.$route.params.id){
          instrument_types.push(instrumentTypes[i])
        }
      }
       return instrument_types;
    },
  },
  props: {
  },
  created(){
    this.$store.state.selected_instrumentType = ""
    this.$store.state.active_item = 1
    this.$store.state.approximateStatus = "disable"
    this.$store.state.instrumentTypeStatus = "incomplete"

    this.$store.state.isInstrumentTypeEnabled = false
    this.$store.state.isApproximateEnabled = false

    this.$store.state.selected_instrumentTypeID = ""
    this.$store.state.isProductsEnabled = "done"

    this.$store.state.updateRate="",
    this.$store.state.powerType="",
    this.$store.state.operatingCondition=""

    this.$store.state.showDisclaimer = false
  },
  components:{Navigation},
  data(){
    return{
      current_page:"it",
      category_id:this.$route.params.id,
      selectedInstrumentType:0
    }
  },
  methods:{
    viewProduct(url){
     window.open(url)
    },
    RouteToResult(selectedInstrumentType,instrumentTypeID,url){
      this.$store.state.selected_instrumentType = selectedInstrumentType
      this.$store.state.selected_instrumentTypeID = instrumentTypeID
      // this.$store.state.isApproximateEnabled = true
      this.$store.state.selected_categoryID = this.category_id
      this.$router.push('/products/'+this.category_id+'/instrument-type/'+instrumentTypeID+'/result/')
      this.$store.state.view_product_result = url
    },
    // preSelectInstrumentType(id,selectedInstrumentType,url){

    //   this.$store.state.selected_instrumentTypeID = id
    //   this.$store.state.selected_instrumentType = selectedInstrumentType
    //   this.$store.state.selected_categoryID = this.category_id
    //   this.$store.state.view_product_result = url

    //   $('#'+this.selectedInstrumentType).removeClass('isActive');
    //   $('#'+id).removeClass('isHidden');
    //   this.selectedInstrumentType = id    
    //   $('#'+id).addClass('isActive');
    // }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #00AA7E;
}
a:hover{
  text-decoration: none;
}
.isActive{
  border: 2px solid #00AA7E;
}
.isHidden{
  visibility:hidden;
}
.v-card{
  border-radius: 0;
  height: 220px;
}
.v-card__text{
  height: 40%;
  font-size: 12px;
  font-weight: bold;
}
.white-container{
  margin:7px;
  margin-right: 15px;
  margin-bottom:10px;
  margin-left: 15px;
  width:775px;
  height: 363px;
  background-color: white;
  padding: 30px;
  overflow-y:auto;
  display: flex;
}
.card {
    cursor: pointer;
    overflow: hidden
}
.v-card{
  border-radius: 0!important;
}
.card-container{
  transition: transform .2s ease;
  cursor: pointer;
  border-radius: 0;
}
.card-container :hover{
   transform: scale(1.02);
}

.title{
  color:black;
  font-size: 15px!important;
  word-break: keep-all;
  padding-top: 10px;
}
.header{
  font-size: 14px;
  color: black;
  font-weight:600;
}
.instrument_image{
  margin-right: 15px;
}
.card-actions{
  display: block;
  justify-content: center;
  background-color: #00AA7E;
  color: white;
}

</style>
